// extracted by mini-css-extract-plugin
export default {"simpleModal":"_192_IIuUeIv7om2wCWJtQD"};